import React, { useEffect } from 'react';

const CheckBox = ({
    field = '',
    label = '',
    value = false,
    isRequired = true,
    key  = 0,
    onChange = () => '',
    onClickLabel = () => '' 
}) => {
    const change = (e) => {
        let event = { target: {} };
        event.target.value = e.target.checked;
        event.target.name = field;
        if (e.target)
            onChange(event);
    }

    return (
        <div className="g-checkbox-ca">
            <div class="checkbox-ca">
                <input type="checkbox" checked={value} onChange={change} name={field} id="checkbox-ca" required={isRequired}  />
                <label for="checkbox-ca"></label>
            </div>
            <span className="lbl-checkbox-ca" onClick={onClickLabel}>
                {label}
            </span>
        </div>
    );
}

export { CheckBox };